import { AnatomicalSystemContentModel } from '../anatomicalSystem/anatomicalSystemContentModel';

export class AnatomicalSystemModel {
  public anatomicalSystemId: number;
  public anatomicalSystemNameBG: string;
  public anatomicalSystemNameEN: string;
  public anatomicalSystemContent: Array<AnatomicalSystemContentModel>;
}